export const getStoredAdmin = () => {
  try {
    const stored = JSON.parse(localStorage.getItem('userData') || '{}');
    return stored?.admin || stored?.user || stored || {};
  } catch (error) {
    return {};
  }
};

export const getStoredAdminId = () => {
  const admin = getStoredAdmin();
  return admin?.id ?? null;
};
